// extracted by mini-css-extract-plugin
export default {"employee":"EmployeeAvatars--employee--4caed6","showHover":"EmployeeAvatars--showHover--d986ea","closeIcon":"EmployeeAvatars--closeIcon--85189a"};